import { addClickOutsideListener } from "./helpers/dialogHelpers";

const groups = <NodeListOf<HTMLDivElement>>document.querySelectorAll(".group-offer");

groups.forEach((group) => {
    const dialogId = group.getAttribute("aria-controls");
    const dialog = <HTMLDialogElement>document.getElementById(dialogId);
    const close = <HTMLButtonElement>dialog.querySelector(".close-button");
    const contact = <HTMLLinkElement>group.querySelector(".contact");

    if (contact) {
        contact.addEventListener("click", (e: MouseEvent) => {
            e.stopImmediatePropagation();
        });
    }

    if (dialog) {
        group.addEventListener("click", () => {
            dialog.showModal();
            dialog.setAttribute("aria-hidden", "false");
        });

        close.addEventListener("click", () => {
            dialog.close();
            dialog.setAttribute("aria-hidden", "true");
        });

        addClickOutsideListener(dialog);

        // Update aria-hidden when dialog state changes
        dialog.addEventListener("toggle", () => {
            if (dialog.open) {
                dialog.setAttribute("aria-hidden", "false");
            } else {
                dialog.setAttribute("aria-hidden", "true");
            }
        });
    }
});
